import React, { useState } from 'react';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import IconChevron from '@/icons/Chevron.svg';
import IconError from '@/icons/Error.svg';
import useViewPort from '@/utils/useViewport';

const Accordion = ({
  trigger,
  children,
  openByDefault = false,
  ariaLabel,
  isInvalid,
}: {
  trigger: React.ReactNode;
  children: React.ReactNode;
  openByDefault?: boolean;
  ariaLabel?: string;
  isInvalid?: boolean;
}) => {
  const { isMobile } = useViewPort();
  const [isOpen, setIsOpen] = useState(openByDefault);

  return (
    <Stack justifyContent="space-between" alignItems="stretch">
      <Button ariaLabel={ariaLabel} variant="style-less" onPress={() => setIsOpen(!isOpen)}>
        <Stack
          style={{ flex: 1 }}
          padding={isMobile ? '0.75rem' : '0.5rem 0'}
          flexWrap="nowrap"
          row
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack
            style={{ textAlign: 'left' }}
            flexWrap="nowrap"
            row
            alignItems="center"
            gap="0.25rem"
          >
            {isInvalid && <IconError className="text-danger" fontSize="1.25rem" />}
            {trigger}
          </Stack>
          <IconChevron down={!isOpen} up={isOpen} />
        </Stack>
      </Button>
      {isOpen && (
        <Stack padding={isMobile ? '0.25rem 0.75rem 0.75rem' : '0.5rem 0'} gap="0.5rem">
          {children}
        </Stack>
      )}
    </Stack>
  );
};

export default Accordion;
